import type { ComponentProps, ReactNode } from 'react'
import { unstable_HistoryRouter as CompatHistoryRouter } from 'react-router'

import { history } from './history'

type CompatHistory = ComponentProps<typeof CompatHistoryRouter>['history']

interface HistoryRouterProps {
  children?: ReactNode
}

// react-router types HistoryRouter.history as its own History (createURL / encodeLocation).
// The documented pairing is history@5 createBrowserHistory; those extra methods are not used at runtime.
export const HistoryRouter = ({ children }: HistoryRouterProps) => (
  <CompatHistoryRouter history={history as unknown as CompatHistory}>{children}</CompatHistoryRouter>
)
